export const credsJQL = (id: any) => {
    return {
        user: [
            'email',
            'isGuide',
            'isVerified',
            'provider',
            {
                profile: [
                    "avatar",
                    "displayName",
                    "firstName",
                    "lastName",
                    "phoneNumber",
                    "aboutMe",
                    "homeBase",
                    "speaking",
                    "phoneNumberCountry",
                    "phoneNumberCode"
                ]
            },
            {
                guideDetail: [
                    "agencyName",
                    "phoneNumber",
                    "bankNumber",
                    "swiftNumber",
                    "iban",
                    "bankAccountHolder",
                    "bankName",
                    "idCardNo",
                    "idCard",
                    "idCardSelfie",
                    "phoneNumber",
                    "address",
                    "addressDetail",
                    "phoneNumberCountry",
                    "phoneNumberCode"
                ]
            }
        ],
        conditions: {
            where: {
                user_id: {
                    equalTo: id
                }
            }
        }
    }
};
